export function isPieceUom(uomLabel?: string | null): boolean {
  return (uomLabel ?? '').trim().toLowerCase() === 'st';
}

export function formatQty(value: string | number | null | undefined, uomLabel?: string | null): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const numeric = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numeric)) {
    return String(value);
  }

  if (isPieceUom(uomLabel)) {
    return String(Math.round(numeric));
  }

  return numeric.toFixed(2).replace(/\.?0+$/, '');
}

export function qtyInputStep(uomLabel?: string | null): '1' | '0.01' {
  return isPieceUom(uomLabel) ? '1' : '0.01';
}
